import { render, staticRenderFns } from "./ticketMessageHeader.vue?vue&type=template&id=199e0cc5&scoped=true&"
import script from "./ticketMessageHeader.vue?vue&type=script&lang=js&"
export * from "./ticketMessageHeader.vue?vue&type=script&lang=js&"
import style0 from "./ticketMessageHeader.vue?vue&type=style&index=0&id=199e0cc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199e0cc5",
  null
  
)

export default component.exports